const libPictView = require('pict-view');
const { ActionCards } = require('headlight-sample-scanning');

/**
 * Printer Codes (#/Printer-Codes): one print button per Scan Samples action card. Reached from the panels'
 * Settings pane ("QR Printer Codes"), not from the navigation menu.
 */
class PrinterCodes extends libPictView
{
	/**
	 * @param {any} pFable
	 * @param {any} pOptions
	 * @param {string} pServiceHash
	 */
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
		/** @type {any} */
		this.options;
	}

	/** @return {string} one row per Scan Samples action card */
	get cardsHTML()
	{
		return ActionCards.map((pCard) => /*html*/`
						<div class="columns is-vcentered">
							<div class="column notification p-2 px-4 m-2 has-text-right">
								<em>${ pCard.Description }</em>
							</div>
							<div class="column is-3">
								<button type="button" id="PrinterCodes-${ pCard.Hash }" class="button is-link is-fullwidth"
									onclick="_Pict.providers.QRCodeProvider.print('${ pCard.Payload }', { printStyle: 'thin', raw: true, footers: ['HLLOGO ${ pCard.Footer }']});">
									<span class="icon mr-3"><i class="fas fa-fw ${ pCard.Icon }"></i></span>
									${ pCard.Label }
								</button>
							</div>
						</div>`).join('');
	}
}

module.exports = PrinterCodes;
module.exports.default_configuration = (
	{
		ViewIdentifier: 'PrinterCodes',
		DefaultRenderable: 'PrinterCodes',
		DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',

		AutoRender: false,

		CSS: '',

		Templates: [
			{
				Hash: 'PrinterCodes-Wrapper',
				Template: /*html*/`
				<section id="PrinterCodes" class="form p-5">
					<h2 class="title is-4 mb-3">Printer Codes</h2>
					<div class="content">{~D:Context[0].cardsHTML~}
					</div>
				</section>`,
			},
		],
		Renderables: [
			{
				RenderableHash: 'PrinterCodes',
				TemplateHash: 'PrinterCodes-Wrapper',
				RenderMethod: 'replace',
			} ],
	});
